import React, { useMemo } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { parseDateInput, formatDate, parseLocalDate } from '../../utils/dateTimeUtils';

/*
  ControlledDateInput
  - Displays a date according to user's date_input_format (US/EU)
  - Accepts free text input in that format and converts to ISO (yyyy-mm-dd) for onChange
  Props:
    valueIso: string (yyyy-mm-dd) or Date/ISO string
    onChangeIso: (isoDateStr) => void  // called with yyyy-mm-dd or '' when cleared/invalid
    placeholder?: string
    className?: string
*/
const ControlledDateInput = ({ valueIso, onChangeIso, placeholder = 'Enter date', className = '' }) => {
  const { user } = useAuth();
  const prefs = user?.ui_preferences || { date_input_format: 'US' };

  const displayValue = useMemo(() => {
    if (!valueIso) return '';
    try {
      // Parse as a local date so a date-only value doesn't render one day
      // earlier for viewers west of UTC (UTC-midnight off-by-one).
      const iso = typeof valueIso === 'string' ? valueIso.split('T')[0] : '';
      const dt = parseLocalDate(iso);
      return dt ? formatDate(dt, prefs) : '';
    } catch {
      return '';
    }
  }, [valueIso, prefs]);

  return (
    <input
      type="text"
      value={displayValue}
      placeholder={prefs?.date_input_format === 'EU' ? 'DD/MM/YYYY' : 'MM/DD/YYYY'}
      onChange={(e) => {
        const txt = e.target.value;
        const iso = parseDateInput(txt, prefs);
        if (onChangeIso) onChangeIso(iso);
      }}
      className={className}
      inputMode="numeric"
      pattern={prefs?.date_input_format === 'EU' ? '[0-9]{2}/[0-9]{2}/[0-9]{4}' : '[0-9]{2}/[0-9]{2}/[0-9]{4}'}
    />
  );
};

export default ControlledDateInput;
